module.exports = __webpack_public_path__ + "static/media/vinceBackground.217c7c20.png";